<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<p class="P_Norm-Center__And__Page_Break" id="auto_bookmark_toc_1"><span>For my test readers, cheerleaders, and dear friends Amy, Kate, and Laura, who told me I could do it when I set myself an ambitious deadline, and then made sure I made it.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?27218a3c